import { render, staticRenderFns } from "./AdSpaceScreenSaverItem.vue?vue&type=template&id=1acfe421&scoped=true&"
import script from "./AdSpaceScreenSaverItem.vue?vue&type=script&lang=ts&"
export * from "./AdSpaceScreenSaverItem.vue?vue&type=script&lang=ts&"
import style0 from "./AdSpaceScreenSaverItem.vue?vue&type=style&index=0&id=1acfe421&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acfe421",
  null
  
)

export default component.exports